<template>
    <div class="home">
        <v-card>
            <v-card-title>Manage Notifications</v-card-title>
            <v-card-text v-if="notificationsSupported">
                Allow notifications to popup on your device, when new activity is seen in your account.
            </v-card-text>
            <v-card-text v-if="!notificationsSupported">
                Notifications are not supported on this device.
            </v-card-text>

            <v-card-actions>
                <v-spacer v-if="notificationsSupported"></v-spacer>
                <v-btn :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" v-if="notificationsSupported"
                    @click="toggleSubscription" :disabled="buttonDisabled">{{
                            (notificationsEnabled ? 'Disable' : 'Enable')
                    }} notifications </v-btn>
                <v-btn v-if="notificationsSupported" @click="createPushNotification" color="red">Test</v-btn>

                <v-alert v-if="!notificationsSupported" class="alerts" dense text outlined
                    :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'" icon="mdi-account-lock">
                    Push Notifications are not enabled in this browser. For IOS devices consider upgrading to IOS 16 as
                    of September 2022.
                </v-alert>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import pushNotificationMixin from '@/mixins/pushNotificationMixin.js';

export default {
    name: 'PushNotification',
    mixins: [pushNotificationMixin],
    data() {
        return {
        }
    },
}
</script>
